<script lang="ts">
  import { KeyboardKey, IconButtonType, ModalCss } from "../enums";
  import { Icons } from "../utilities/icons";

  import Modal from "../components/Modal.svelte";
  import IconButton from "../components/IconButton.svelte";

  let { message, yes, no } = $props();

  const yesAnswer = (e: Event): void => {
    e.preventDefault();
    yes();
  };

  const handleKeydown = (event: KeyboardEvent): void => {
    if (event.key === KeyboardKey.Enter) {
      yesAnswer(event);
    } else if (event.key === KeyboardKey.Escape) {
      no();
    }
  };
</script>

<!-- HTML ===================================================== -->

<svelte:window onkeydown={handleKeydown} />
<Modal size={ModalCss.Size.Large}>
  <form onsubmit={yesAnswer}>
    <div class="content">
      <div class="text">
        {@render message()}
      </div>
    </div>
    <div class="bottom-box">
      <IconButton
        onclick={() => no()}
        textMediumScaled={true}
        icon={Icons.WindowClose}
      >
        {#snippet message()}Nej{/snippet}
      </IconButton>
      <span class="ok-btn">
        <IconButton
          onclick={() => yesAnswer}
          textMediumScaled={true}
          type={IconButtonType.Submit}
          icon={Icons.Check}
        >
          {#snippet message()}Ja{/snippet}
        </IconButton>
      </span>
    </div>
  </form>
</Modal>

<!-- CSS ====================================================== -->
<style>
  .ok-btn {
    margin-left: auto;
  }
  .text {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .content {
    font-size: 3.5vmin;
    padding: 3vmin 2vmin;
    display: flex;
    flex-direction: column;
    align-items: space-between;
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
    padding: 2vmin;
  }
</style>
